<svelte:head>

</svelte:head>


<script>

import { onMount, onDestroy } from 'svelte';


import MySlider			from './Page_0005_Slider.svelte';   


   let slider_value = 0;

	onMount(async () => {
		  
	});

</script>


<style>

	.applet {
	}
	
 
</style>


<div class="applet">

	<div>
		<div>My Finances :: Financial Statements</div>
		<div>App Slider_0005</div>
		<div>
		<p>test slider</p>
		<MySlider />
		</div>
	</div>

</div>
